import React, { useContext, useState } from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { ThemeContext } from './ThemeContext';
import {
  DOWNLOAD_URL,
  HOME_URL,
  DOCS_URL,
  PRICING_URL,
  TERMS_URL,
  PRIVACY_URL,
} from './utils/urls';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import Proba from './components/Proba';
import Pricing from './pages/Pricing';
import DownloadPage from './pages/DownloadPage';

import Docs from './pages/Docs';
import TermsOfService from './pages/ToS&PP/TermsOfService';
import PrivacyPolicy from './pages/ToS&PP/PrivacyPolicy';
import AnimatedBackground from './components/Backround/Backround1';

const AppContent = () => {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();
  const isHome = location.pathname === HOME_URL;

  return (
    <div className="app-container" data-bs-theme={theme}>
      <Navbar />

      <div className="content-scrollable-wrapper d-flex flex-column flex-grow-1 overflow-y-auto scroller bg-main">
        <main className="main-content d-flex flex-column">
          <Routes>
            <Route exact path={HOME_URL} element={<Home />} />
            <Route exact path={DOWNLOAD_URL} element={<DownloadPage />} />
            <Route exact path={PRICING_URL} element={<Pricing />} />
            <Route exact path={TERMS_URL} element={<TermsOfService />} />
            <Route exact path={PRIVACY_URL} element={<PrivacyPolicy />} />
            <Route path={DOCS_URL + '/:sectionId'} element={<Docs />} />
            <Route
              exact
              path={DOCS_URL}
              element={<Navigate to={DOCS_URL + '/getting-started'} replace />}
            />
            <Route path="*" element={<Navigate to={HOME_URL} replace />} />
          </Routes>
        </main>
        {!isHome && <Proba />}
      </div>
    </div>
  );
};

// Separate component to handle background logic
const BackgroundWrapper = () => {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();
  const isDarkTheme = theme === 'dark';

  // Pages without background
  const pagesWithoutBackground = [PRIVACY_URL, TERMS_URL];
  const shouldShowBackground = !pagesWithoutBackground.includes(
    location.pathname
  );

  if (!shouldShowBackground) {
    return null;
  }

  return (
    <AnimatedBackground
      className="position-fixed w-100 h-100"
      theme={isDarkTheme ? 'dark' : 'light'}
      opacity={isDarkTheme ? 0.8 : 0.7}
      style={{
        top: 0,
        left: 0,
        zIndex: 1,
      }}
    />
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <BackgroundWrapper />
      <AppContent />
    </Router>
  );
};

export default AppRoutes;
